import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<p>Простая и элегантная подарочная упаковка в виде коробки-куба размером 125х125х85 мм украсит и защитит вашу кружку или другой товар подходящего размера. Придумайте и разместите свой дизайн и поздравительную надпись на крышке или любой из боковых сторон коробки. Упаковка сделана из качественного картона, а нанесение производится прямой цифровой печатью. Производство от 1 шт., срок изготовления - от 1-го дня.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
